<template>
    <div class="snackbar">
        <v-snackbar v-model="success" color="success">
            {{ message }}
            <v-btn v-if="closable" color="white" text @click="success = false"> Fermer </v-btn>
        </v-snackbar>
        <v-snackbar v-model="error" color="error">
            {{ message }}
            <v-btn v-if="closable" color="white" text @click="error = false"> Fermer </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import { EventBus } from "src/bus/eventBus";

export default {
    data() {
        return {
            success: false,
            error: false,
            closable: true,
            message: "",
        };
    },
    mounted() {
        EventBus.$on("alert:success", ({ message }) => {
            this.success = true;
            this.message = message;
        });
        EventBus.$on("alert:error", ({ message, closable }) => {
            this.error = true;
            this.message = message;
            this.closable = closable;
        });
    },
};
</script>

<style lang="sass" scoped></style>
